import MatestackUiVueJs from "matestack-ui-vuejs";

// Sidecar for Web::Components::CopyButton. Writes props.text to the clipboard,
// falling back to a hidden textarea and execCommand where the async clipboard
// API is unavailable or refused, then reports "copied" or "failed" for 1.5s.
const RESET_MS = 1500;

const copyButton = {
  mixins: [MatestackUiVueJs.componentMixin],
  template: MatestackUiVueJs.componentHelpers.inlineTemplate,
  data() {
    return { state: null, timer: null };
  },
  beforeUnmount() {
    clearTimeout(this.timer);
  },
  methods: {
    async copy() {
      const text = String(this.props["text"] || "");
      let ok = false;
      try {
        await navigator.clipboard.writeText(text);
        ok = true;
      } catch (e) {
        ok = this.fallbackCopy(text);
      }
      this.state = ok ? "copied" : "failed";
      clearTimeout(this.timer);
      this.timer = setTimeout(() => (this.state = null), RESET_MS);
    },
    fallbackCopy(text) {
      const area = document.createElement("textarea");
      area.value = text;
      area.setAttribute("readonly", "");
      area.style.position = "fixed";
      area.style.opacity = "0";
      document.body.appendChild(area);
      area.select();
      try {
        return document.execCommand("copy");
      } catch (e) {
        return false;
      } finally {
        area.remove();
      }
    },
  },
};

export default copyButton;
